import { PortoLogoIcon } from '@latitude/icons';
import { Text } from '@latitude/text';
import { animated, useTransition } from '@react-spring/web';
import {
  getFormPageIllustration,
  getLoginLink,
} from 'components/porto/Signup/helpers';
import Image from 'next/image';

import {
  PORTO_SIGNUP_FORM_PAGES,
  PORTO_SIGNUP_FORM_TITLES_BY_PAGE,
} from '../../constants';
import type { PortoSignupFormPage } from '../../types';

type Props = {
  page: PortoSignupFormPage;
};

const ILLUSTRATION_ALT_TEXT_BY_PAGE = {
  [PORTO_SIGNUP_FORM_PAGES.COMPLETE_YOUR_PROFILE]:
    'Complete your profile illustration',
  [PORTO_SIGNUP_FORM_PAGES.ORGANIZATION_DETAILS]:
    'Organization details illustration',
};

function SideBannerContent({ page }: Props) {
  const transitionFade = useTransition([page], {
    from: { opacity: 0 },
    enter: { opacity: 1, delay: 200 },
    leave: { opacity: 0 },
    config: { duration: 200 },
  });

  return (
    <div className="relative flex size-full flex-col items-start justify-between bg-color-ref-primary-primary-50 p-10">
      <PortoLogoIcon className="absolute left-10 top-9 h-11 text-black" />
      <div className="grid h-full">
        {transitionFade((style, page) => (
          <animated.div
            className="col-span-full row-span-full flex h-full flex-col items-center justify-center gap-10 text-center"
            style={style}
          >
            <Image
              loading="eager"
              width={395}
              src={getFormPageIllustration(page)}
              alt={ILLUSTRATION_ALT_TEXT_BY_PAGE[page]}
            />
            <Text variant="headingLarge" className="text-black">
              {PORTO_SIGNUP_FORM_TITLES_BY_PAGE[page]}
            </Text>
          </animated.div>
        ))}
      </div>
      <div className="flex w-full justify-center text-black">
        <Text>
          {`${'Already have an account? '}`}
          <a className="font-bold" href={getLoginLink()}>
            Log in
          </a>
        </Text>
      </div>
    </div>
  );
}

export default SideBannerContent;
